<template>
  <div class="box8">
    <div class="title">课程与时俱进，不断融入热门技术</div>
    <div class="subject-content">
      <swiper :options="swiperOption" ref="mySwiper">
        <swiper-slide
          v-for="(item, index) in list"
          :key="index"
          :class="'block' + (index + 1)"
        >
          <div class="slide">
            <div class="slideTitle">{{ item.head }}</div>
            <div
              class="slideItem"
              v-for="item2 in item.content"
              :key="item2.arr"
            >
              <p>
                <img
                  src="../../../assets/coursePage/pythonData/box8/icon1.png"
                  alt=""
                />
                {{ item2.title }}
              </p>
              <p>{{ item2.arr }}</p>
            </div>

            <div class="slideItemSpecial">
              <p v-if="item.lastcontent">
                <img
                  src="../../../assets/coursePage/pythonData/box8/icon2.png"
                  alt=""
                />
                {{ item.lastcontent.title }}
              </p>
              <p v-if="item.lastcontent">{{ item.lastcontent.arr }}</p>
              <p v-if="item.lastcontent2">
                <img
                  src="../../../assets/coursePage/pythonData/box8/icon2.png"
                  alt=""
                />
                {{ item.lastcontent2.title }}
              </p>
              <p v-if="item.lastcontent2">{{ item.lastcontent2.arr }}</p>
            </div>
          </div>
        </swiper-slide>
      </swiper>
      <div class="swiper-pagination-box6"></div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      list: [
        {
          head: "大数据开发入门",
          content: [
            {
              title: "Linux",
              arr: "基本命令、用户管理、VI、权限管理、网络管理、SSH",
            },
            {
              title: "MySQL",
              arr: "DDL、DML、DQL、多表查询、分组查询、约束",
            },
            { title: "Kettle", arr: "数据转换、脚本组件、Job开发" },
            { title: "BI工具", arr: "基本操作、常用图表、仪表板" },
          ],
          lastcontent: { title: "阶段案例实战", arr: "传统数据仓库实战" },
        },
        {
          head: "大数据核心基础",
          content: [
            {
              title: "Zookeeper",
              arr: "架构原理、存储模型、ZK集群搭建、选举机制",
            },
            {
              title: "Hadoop HDFS",
              arr: "HDFS架构、Block块存储、读写流程、NameNode、DataNode、高可用集群",
            },
            {
              title: "Hadoop MapReduce",
              arr: "核心原理、执行流程、Shuffle机制",
            },
            {
              title: "Hadoop YARN",
              arr: "YARN组件、架构原理、执行流程、调度器",
            },
            {
              title: "Hive",
              arr: "HQL、数据类型、分区分桶、拉链表、元数据、数据压缩、存储格式、原理架构、性能优化",
            },
          ],
          lastcontent: { title: "阶段案例实战", arr: "社交APP案例实战" },
        },
        {
          head: "千亿级数仓技术",
          content: [
            { title: "CDH", arr: "CM架构、组件构建、CM实操" },
            {
              title: "基于阿里数仓分层架构",
              arr: "ODS、DIM、DWS、DWD、DM、ADS",
            },
            { title: "Hive + Presto", arr: "架构原理、SQL调优、集群构建" },
            { title: "Hive 性能调优", arr: "数据倾斜、JOIN调优、HIVE索引" },
            { title: "调度", arr: "DS、Oozie" },
          ],
          lastcontent: {
            title: "阶段案例实战",
            arr: "在线教育大数据数仓、新零售大数据数仓",
          },
        },
        {
          head: "PB级内存计算",
          content: [
            {
              title: "Python编程",
              arr: "基本语法、数据结构、函数、面向对象、异常处理、模块与包、网络编程、多进程、多线程、闭包、装饰器、迭代器",
            },
            {
              title: "Spark",
              arr: "架构原理、Spark RDD、Spark DF、Spark DAG、Spark SQL、内存迭代、性能调优、任务调度、Pandas on Spark、Spark on Hive、Spark Shuffle、Spark 3.x 新特性",
            },
          ],
          lastcontent: {
            title: "阶段案例实战",
            arr: "工业项目实战、保险大数据实战",
          },
        },
        {
          head: "亚秒级实时计算",
          content: [
            {
              title: "Flink Core",
              arr: "架构原理、批流一体、Window操作、State操作、DataStream、Checkpoint、Flink SQL、任务调度、负载均衡、状态管理、Runtime、执行计划、Flink性能监控与调优、Flink + Elasticsearch、Flink + Kafka、Flink + Pulsar、Flink + ClickHouse、Flink + Doris",
            },
          ],
          lastcontent: { title: "阶段案例实战", arr: "车联网项目实战" },
        },
        {
          head: "大厂面试",
          lastcontent: {
            title: "面试真题",
            arr: "编程语言SQL、Hadoop生态、Hive、SparkFlink",
          },
          lastcontent2: {
            title: "大厂架构",
            arr: "美团点评数仓架构、小米大数据架构、平安大数据架构",
          },
        },
      ],

      swiperOption: {
        loop: false, // 循环模式选项
        slidesPerView: "auto",
        // centeredSlides: true,
        // paginationClickable: true,
        // spaceBetween: 20,
        // effect: "left",
        pagination: {
          el: ".swiper-pagination-box6",
        },
      },
    };
  },
};
</script>

<style lang="less" scoped>
.box8 {
  position: relative;
  padding-top: 80px;
  width: 100%;

  .title {
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #002233;
    line-height: 56px;
    text-align: center;
  }

  .subject-content {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    margin-top: 10px;
  }
  /deep/.swiper-wrapper {
    padding-bottom: 88px;
    padding-top: 40px;
    box-sizing: border-box;
  }
  .swiper-slide {
    margin-left: 48px;
    width: 600px;
    height: 896px;
    background-size: contain;
    display: flex;
    flex-shrink: 0;

    position: relative;
    width: 600px;
    height: 896px;
    background: #ffffff;
    box-shadow: 0px 8px 32px 0px rgba(199, 225, 255, 0.6);

    border-radius: 20px;

    .slide {
      width: 600px;
      height: 896px;
      padding-right: 32px;
      background: url("../../../assets/coursePage/pythonData/box8/itenbgc.png");
      background-size: contain;
      background-position: center;
      padding-top: 24px;
      box-sizing: border-box;
      .slideTitle {
        width: 260px;
        height: 64px;
        background: linear-gradient(200deg, #66c7ff 0%, #3dafff 100%);
        border-radius: 0px 200px 200px 200px;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 64px;
        text-align: center;
        margin-left: -16px;
        margin-bottom: 32px;
      }
      .slideItem {
        margin-bottom: 24px;
        margin-left: 32px;
        p:nth-child(1) {
          display: flex;
          align-items: center;
          img {
            width: 16px;
            height: 16px;
            background-size: cover;
            margin-left: 4px;
            margin-right: 12px;
          }
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #3dafff;
          line-height: 40px;
        }
        p:nth-child(2) {
          margin-top: 8px;
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #4e5969;
          line-height: 40px;
        }
      }
      .slideItemSpecial {
        margin-bottom: 24px;
        margin-left: 32px;
        p:nth-child(1),
        p:nth-child(3) {
          display: flex;
          align-items: center;
          img {
            width: 16px;
            height: 16px;
            background-size: cover;
            margin: 0 12px 0 4px;
          }
          font-size: 28px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ff9500;
          line-height: 40px;
        }
        p:nth-child(2),
        p:nth-child(4) {
          margin-top: 8px;
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #4e5969;
          line-height: 40px;
          margin-bottom: 24px;
        }
      }
    }
  }
  // .swiper-slide:nth-child(6) {
  //   width: 412px;
  // }
  .block6 {
    margin-right: 48px;

    background-size: cover;
    .slide {
      background: url("../../../assets/coursePage/pythonData/box8/itembgc2.png");
      background-position: center;
      width: 600px;
      height: 896px;
      box-shadow: 0px 8px 32px 0px rgba(238, 210, 189, 0.19) !important;
      border-radius: 20px;
      background-size: contain;
    }
    .slideTitle {
      background: linear-gradient(200deg, #ffe792 0%, #ffa370 100%) !important;
    }
  }
  .swiper-pagination-box6 {
    display: flex;
    align-items: center;
    position: absolute;
    left: 50%;
    margin-top: 32px;
    transform: translate(-50%, 0px);
    height: 6px;
    background: #b7a9ff;
    border-radius: 3px;
    display: none;
  }

  /deep/ .swiper-pagination-bullet {
    width: 20px;
    height: 6px;
    background: #b7a9ff;
    border-radius: 3px;
  }

  /deep/.swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 20px;
    height: 6px;
    background: #775cff;
    border-radius: 3px;
  }
  .button {
    width: 690px;
    height: 96px;
    background: linear-gradient(180deg, #9896ff 0%, #6b62fb 100%);
    box-shadow: 0px 10px 20px 0px #d9dbfc, 0px 4px 16px 0px #bebbff;
    border-radius: 48px;
    margin: 96px auto 0;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 96px;
    text-shadow: 0px 6px 5px rgba(127, 122, 253, 0.77);
    text-align: center;
  }
}
</style>
